import React, { FunctionComponent, useEffect, useState } from "react";
import { FormInput, FormInputNumber, FormRow, FormSelect } from "../formRow/FormRow";
import { MediaContentType, MediaContentTypeOption, MediaModel, MediaType, mediaContentTypeOptions } from "../../../api/mediaApi";
import "./FileInfo.css";
import { addLeadingZero, formatDuration, getYoutubeImageUrlById } from "../../../services/common";
import { formatDate, formatTime } from "../../../services/dateService";
import { CampaignPeriod, CampaingListModel } from "../../../api/campaingsApi";
import { Button } from "../Button";
import Select, { SingleValue } from "react-select";

type Option<T> = { value: T, label: string} 

interface FileInfoImageProps {
    mode: 'readonly' | 'edit',
    mediaInfo: MediaModel,
    mediaCategories: Option<number>[] | [],
    onUpdateMediaInfo: (id : string, newName: string, newDuration: number, mediaType: MediaType, contentType: MediaContentType, clockID: string, mediaCateforyId: number | null) => Promise<void>
}
 
const FileInfoImage: FunctionComponent<FileInfoImageProps> = (props) => {

    let { mode, mediaInfo, mediaCategories, onUpdateMediaInfo} = props;

    let [updateName, setUpdateName] = useState<string>(mediaInfo.name);
    let [updateDuration, setUpdateDuration] = useState<string>(mediaInfo.durationMs/1000+"");
    let [isUpdateNameError, setIsUpdateNameError] = useState<boolean>(false);
    let [isUpdateDurationError, setIsUpdateDurationError] = useState<boolean>(false);
    let [isValidUpdateState, setIsValidUpdateState] = useState<boolean>(true);
    let [clockID, setClockID] = useState('');

    let [selectedContentTypeOption, setSelectedContentTypeOption] = useState<SingleValue<MediaContentTypeOption>>(mediaContentTypeOptions[0]);
    let [selectedMediaCategory, setSelectedMediaCategory]= useState<SingleValue<Option<number>>>(null)

    useEffect(()=>{
        setUpdateName(mediaInfo.name);
        setUpdateDuration(mediaInfo.durationMs/1000+"");
        let contentTypeCurrentOption = mediaContentTypeOptions.filter(it => it.type === mediaInfo.contentType)[0];
        setSelectedContentTypeOption(contentTypeCurrentOption)
        setClockID(mediaInfo.clockId)
        setSelectedMediaCategory(getCategoryById(mediaInfo.taxonomiesCategoryId))
    },[mediaInfo]);

    useEffect(()=>{
        !isUpdateDurationError && !isUpdateNameError ? setIsValidUpdateState(true) : setIsValidUpdateState(false);
    },[isUpdateDurationError, isUpdateNameError]);

    const updateNameHandler = (newValue: string) => {
        if(newValue === '') {
            setIsUpdateNameError(true);
            setUpdateName('');
        } else { setIsUpdateNameError(false); setUpdateName(newValue)}
    }

    const updateDurationHandler = (newValue: string) => {
        let curNewValue = +newValue;
        if( curNewValue < 0 ){
            setIsUpdateDurationError(true)
        } else {setIsUpdateDurationError(false); setUpdateDuration(newValue)}
    }

    const onSelectedContentTypeOption = (newValue: SingleValue<MediaContentTypeOption>) => {
        setSelectedContentTypeOption(newValue)
    }

    const onChangeSelectedMediaCategory = (newValue: SingleValue<Option<number>>) => {
       setSelectedMediaCategory(newValue)
    }

    const getCategoryById = (id: number | null) => {
        if (id == null) return null;
        return mediaCategories.find(it => it.value === id) || null;
    }

    const renderPeriod = (period: CampaignPeriod) => {
        return <p>{formatDate(period.startDate)}-{formatDate(period.endDate)}</p>
    }

    const renderCampaignRow = (campaign: CampaingListModel) => {
        return <tr>
                <td>
                    {campaign.name}
                </td>
                <td>
                    {campaign.periods.map(renderPeriod)}
                </td>
            </tr>
    }

    return (
        <>
            {mediaInfo &&
            <div className="preview-container">
                <div className="preview-img">
                    {mediaInfo.mediaType == MediaType.Image &&
                        <img src={mediaInfo.previewLink} alt="" />
                    }
                    {mediaInfo.mediaType == MediaType.Video &&
                        <video width="100%" height="500" controls={true} id={`${mediaInfo.id}_video`} src={mediaInfo.webVideoLink}>
                        </video>
                    }
                    {mediaInfo.mediaType == MediaType.Youtube &&
                        <img src={mediaInfo.previewLink} alt="" />
                    }
                    {mediaInfo.mediaType == MediaType.YoutubeLive &&
                        <img src={mediaInfo.previewLink} alt="" />
                    }
                </div>
                <div className="preview-info-block">
                    <h2 className="preview-info-title">Info</h2>
                    <div className="preview-info-group">
                        <FormRow>
                            {mode == 'edit'
                                ? <FormInput
                                    title="Name"
                                    id="update-name-id"
                                    value={updateName}
                                    isError={isUpdateNameError}
                                    errorMessage="Invalid name"
                                    onChange={()=>{}}
                                    onChangeValue={updateNameHandler}
                                />
                                : <><p className="label">Name</p><p>{updateName}</p></>
                            }
                        </FormRow>

                        <FormRow>
                            <label>Content Type</label>
                            {mode == 'edit'
                                ? <Select
                                    className={`w-100`}
                                    classNamePrefix={`select`}
                                    options={mediaContentTypeOptions}
                                    filterOption={(option, input) => option.label.toLowerCase().includes(input.toLowerCase())}
                                    getOptionLabel={(option) => `${option.name}`}
                                    getOptionValue={(option) => `${option.type}`}
                                    onChange={onSelectedContentTypeOption}
                                    value={selectedContentTypeOption}
                                    isMulti={false}
                                />
                                : <p>{selectedContentTypeOption?.name ?? '—'}</p>
                            }
                         </FormRow>

                        <FormRow>
                            {mode == 'edit'
                                ? <FormInput
                                    title="Clock ID"
                                    id="clock-id"
                                    value={clockID}
                                    isError={false}
                                    errorMessage=""
                                    onChange={()=>{}}
                                    onChangeValue={(v) => setClockID(v)}
                                />
                                : <><p className="label">Clock ID</p><p>{clockID || '—'}</p></>
                            }
                        </FormRow>

                        <FormRow>
                            <label>Media Category</label>
                            {mode == 'edit'
                                ? <Select
                                    className={`w-100`}
                                    classNamePrefix={`select`}
                                    options={mediaCategories}
                                    onChange={onChangeSelectedMediaCategory}
                                    value={selectedMediaCategory}
                                    isMulti={false}
                                    isClearable
                                />
                                : <p>{selectedMediaCategory?.label ?? '—'}</p>
                            }
                        </FormRow>
                    </div>
                    {(mediaInfo.mediaType == MediaType.Youtube || mediaInfo.mediaType == MediaType.YoutubeLive ) && <div className="preview-info-group">
                        <p className="label">URL</p>
                        <p>{mediaInfo.url}</p>
                    </div>}
                    {!(mediaInfo.mediaType == MediaType.Youtube || mediaInfo.mediaType == MediaType.YoutubeLive ) && <div className="preview-info-group">
                        <p className="label">File size (MB)</p>
                        <p>({mediaInfo.sizeMb}MB)</p>
                    </div>}
                    <div className="preview-info-group">
                        {(mode == 'readonly' || mediaInfo.mediaType == MediaType.Video) && <>
                            <p className="label">Duration</p>
                            <p>{formatDuration(mediaInfo.durationMs)}</p>
                        </>}
                        {(mode == 'edit' && mediaInfo.mediaType == MediaType.Image) && <FormInputNumber
                            id="time-select"
                            title="Duration (sec)"
                            isError={isUpdateDurationError}
                            errorMessage="Select correct duration"
                            min={0}
                            max={3000}
                            step={1}
                            value={updateDuration}
                            onChange={()=>{}}
                            onChangeValue={updateDurationHandler}
                        />
                        }
                        
                    </div>
                    <div className="preview-info-group">
                        <p className="label">Uploaded</p>
                        <p>{formatDate(mediaInfo.uploadTime)}</p>
                    </div>

                    <table className="preview-campaign-table">
                        <thead>
                            <tr>
                                <td>Campaign</td>
                                <td>Campaign Dates</td>
                            </tr>
                        </thead>
                        <tbody>
                            {mediaInfo.campaigns.map(renderCampaignRow)}
                        </tbody>
                    </table>
                    <br />
                    { mediaInfo.mediaType == MediaType.Video &&
                            <div className="preview-info-group">
                                <a href={mediaInfo.webVideoLink} download={mediaInfo.name}>Download</a>
                            </div>                     
                    }
                    
                    <br />
                    {mode == 'edit' && <div>
                        <Button color="green" label="Update" onClick={()=>{
                            if(isValidUpdateState) onUpdateMediaInfo(mediaInfo.id, updateName, (+updateDuration)*1000, mediaInfo.mediaType, selectedContentTypeOption!.type, clockID, selectedMediaCategory ? selectedMediaCategory.value : null)
                        }}/>
                    </div >}
                  
                    <div>
                        
                    </div>


                </div>
            </div>
            }
        </>
    );
    
}
 
export default FileInfoImage;